<template>
  <SidebarClientTemplate
    :show="showSidebar"
    :disabledSubmit="disabledSubmit"
    @closeSidebar="showModalCancelFunc"
    @submit="handleSubmit"
  >
    <template v-slot:bodySidebar>
      <b-loading :is-full-page="true" v-model="isLoadingSubmit" :can-cancel="false">
        <SpinnerIcon />
      </b-loading>
      <div>
        <p class="averta-black label-20 mb-4">Edit {{renderTitleBranch}}</p>
        <ClientInfo
          currentTab="branch"
          class="mb-5"
          :typeSection="typeSection"
          :name="name"
          :companyName="companyName"
          :logo="logo"
        />

        <div class="wrap-client">
          <div class="mb-5">
            <p class="averta-black label-20">Informasi {{renderTitleBranch}}</p>
          </div>
          <div class="is-flex is-justify-content-space-between is-align-items-center mb-5">
            <p class="label-14 mr-3 white-space-nowrap">
              <span class="averta-bold">Nama {{renderTitleBranch}} </span>
              <span class="text-merah">*</span>
            </p>
            <input
              type="text"
              class="input"
              :placeholder="`Masukkan nama ${renderTitleBranch}`"
              v-model="branchName"
            />
          </div>
          <div v-if="isSMRC" class="flex-center-vertical mt-4">
          <div class="input-label mr-3">
            <p class="averta-bold">Logo <span class="color-red">*</span></p>
          </div>
          <div class="flex-center-vertical">
            <label for="branch-logo-file-edit" class="flex-center-vertical">
              <div v-if="branchLogo" class="is-relative">
                <div class="preview-crop-img is-clickable">
                  <img :src="branchLogo" alt="" />
                </div>
                <div class="edit-image">
                  <EditIcon />
                </div>
              </div>
              <div v-else class="flex-center-vertical is-clickable input-search-1 bg-grey-3">
                <UploadLightIcon />
                <p class="ml-1">Upload Foto</p>
              </div>
            </label>
            <input
              type="file"
              id="branch-logo-file-edit"
              class="d-none"
              ref="branchImgEdit"
              @change="uploadImageFile"
              hidden
              accept="image/png, image/jpeg"
            />
          </div>
        </div>
        </div>
      </div>

      <!-- Modal Cancel -->
      <ModalConfirm
        :showModal="showModalCancel"
        imageProps="sunset.png"
        :titleProps="`Batalkan Perubahan ${renderTitleBranch}?`"
        descProps="Jika data sudah diisi maka akan dihapus oleh sistem"
      >
        <template v-slot:button>
          <div class="is-flex is-align-items-center mt-4">
            <ButtonApp
              :isSecondary="true"
              :is-bold="true"
              width="185px"
              height="52px"
              class="mr-3"
              @click="cancelClose"
            >
              Kembali
            </ButtonApp>
            <ButtonApp :is-bold="true" width="185px" height="52px" @click="handleCloseSidebar">
              Batalkan Perubahan
            </ButtonApp>
          </div>
        </template>
      </ModalConfirm>
      <!-- Modal Cancel -->

      <!-- Modal Submit -->
      <ModalConfirm
        :showModal="showModalConfirm"
        imageProps="sunset.png"
        titleProps="Semua Data Yang Dimasukkan Sudah Benar?"
        descProps="Pastikan kamu sudah melakukan pengecekkan sebelum diubah"
      >
        <template v-slot:button>
          <div class="is-flex is-align-items-center mt-4">
            <ButtonApp
              :isSecondary="true"
              :is-bold="true"
              width="185px"
              height="52px"
              class="mr-3"
              @click="cancelClose"
            >
              Batalkan
            </ButtonApp>
            <ButtonApp :is-bold="true" width="185px" height="52px" @click="confirmModal">
              Simpan Perubahan
            </ButtonApp>
          </div>
        </template>
      </ModalConfirm>
      <!-- Modal Submit -->

      <ModalCropImage
        :showModal="showModalCropImage"
        :previewImage="previewLogo"
        :closeModal="closeModalCropImage"
        @cropImage="cropImage($event)"
      />

    </template>
  </SidebarClientTemplate>
</template>

<script>
import { mapGetters } from 'vuex'
import { SpinnerIcon, EditIcon, UploadLightIcon } from '@/components/icons'
import { alertErrorMessage, isSMRC, titleBranch, titlePICBranch } from '@/helpers'
import SidebarClientTemplate from '@/components/sidebar/SidebarClientTemplate.vue'
import ButtonApp from '@/components/button/ButtonApp.vue'
import ModalConfirm from '../ModalConfirm.vue'
import ClientInfo from './ClientInfo.vue'
import ModalCropImage from '../client-components/ModalCropImage.vue'

export default {
  name: 'SidebarEditBranch',
  components: {
    SidebarClientTemplate,
    SpinnerIcon,
    ModalConfirm,
    ClientInfo,
    ButtonApp,
    EditIcon,
    UploadLightIcon,
    ModalCropImage
  },
  props: {
    show: {
      type: Boolean
    },
    close: {
      type: Function
    },
    selectedBranch: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      detailClient: 'client/getPayloadClientSelectedBranch',
      getBranchImgFile: 'client/getBranchImgFile'
    }),
    isSMRC () {
      return isSMRC(this.detailClient.code)
    },
    renderTitleBranch () {
      return titleBranch(this.detailClient.code)
    },
    renderTitlePICBranch () {
      return titlePICBranch(this.detailClient.code)
    }
  },
  data () {
    return {
      showSidebar: false,
      showModalConfirm: false,
      showModalCancel: false,
      showModalCropImage: false,
      isLoadingSubmit: false,
      disabledSubmit: false,
      typeSection: '',
      name: '',
      companyName: '',
      logo: '',
      branchName: '',
      branchLogo: null,
      branchImgFile: null,
      previewLogo: ''
    }
  },
  methods: {
    cancelClose () {
      this.showModalConfirm = false
      this.showModalCancel = false
    },
    showModalCancelFunc () {
      if (this.branchName !== this.selectedBranch.name && this.branchName !== '') {
        this.showModalCancel = true
      } else {
        this.handleCloseSidebar()
      }
    },
    confirmModal () {
      this.isLoadingSubmit = true
      this.showModalConfirm = false

      const payload = {
        url: this.url,
        branch_id: this.selectedBranch.id,
        name: this.branchName
      }

      if (this.isSMRC && this.getBranchImgFile) {
        payload.logo = this.getBranchImgFile
      }

      this.$store
        .dispatch('client/updateBranch', payload)
        .then(response => {
          this.isLoadingSubmit = false
          this.showSidebar = false
          this.close()
          this.$emit('updateBranch')
          this.$buefy.toast.open({
            message: '<p class="averta-regular">Data Berhasil Di Ubah</p>',
            type: 'is-success'
          })
        })
        .catch((error) => {
          alertErrorMessage(error)
          this.isLoadingSubmit = false
        })
    },
    handleSubmit () {
      this.showModalConfirm = true
    },
    handleCloseSidebar () {
      this.showModalCancel = false
      this.showSidebar = false
      this.close()
    },
    disableButton (value) {
      if (value === '') {
        this.disabledSubmit = true
      } else if (value !== this.selectedBranch.name || (this.isSMRC && this.selectedBranch.branch_logo !== this.branchLogo)) {
        this.disabledSubmit = false
      } else {
        this.disabledSubmit = true
      }
    },
    uploadImageFile (e) {
      e.preventDefault()
      if (e.target.files[0]) {
        this.previewLogo = URL.createObjectURL(e.target.files[0])
        this.showModalCropImage = true
        this.$refs.branchImgEdit.value = ''
      }
    },
    closeModalCropImage () {
      this.showModalCropImage = false
    },
    cropImage (result) {
      const { preview, file } = result

      this.branchLogo = preview
      this.branchImgFile = file
      this.showModalCropImage = false
      this.$store.commit('client/setPayloadAddBranch', {
        type: 'branchLogo',
        branchImgFile: file
      })
    }
  },
  watch: {
    show (value) {
      this.showSidebar = value
      if (value) {
        this.typeSection = 'information'
        if (this.detailClient) {
          this.name = this.detailClient.name
          this.companyName = this.detailClient.company_name
          this.logo = this.detailClient.logo
        }

        if (this.selectedBranch) {
          this.branchName = this.selectedBranch.name
          this.branchLogo = this.selectedBranch.branch_logo || ''
        }
      }
    },
    branchName (newValue) {
      this.disableButton(newValue)
    },
    branchLogo () {
      this.disableButton(this.branchName)
    }
  }
}
</script>

<style scoped>
.preview-crop-img {
  height: 70px;
}

.preview-crop-img img {
  height: 100%;
}

.edit-image {
  position: absolute;
  right: -20px;
  bottom: 0px;
}

.input-label {
  width: 105px;
}
</style>
